export default "__VITE_ASSET__i1SBa_SM__"